import React from 'react';
import PropTypes from 'prop-types';
import $ from 'jquery';
import _ from 'underscore';

import { withUiBlock } from '@bingads-webui/uiblocker';
import { createAsyncToken, generateGuid } from '@bingads-webui-universal/primitive-utilities';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { getDisplayName } from '@bingads-webui-react/hoc-utils';
import { SUPPORT_ADINSIGHT_AUTO_APPLY_TYPES } from '../consts';

export const withGetAutoApplyOptInStatus = (WrappedComponent) => {
  class HoC extends React.Component {
    static displayName = `withGetAutoApplyOptInStatus(${getDisplayName(WrappedComponent)})`;

    static propTypes = {
      dataService: PropTypes.shape({
        getAutoApplyOptInStatus: PropTypes.func.isRequired,
      }).isRequired,
      permissions: PropTypes.shape({}),
      isMCC: PropTypes.bool,
    };

    static defaultProps = {
      permissions: {},
      isMCC: false,
    };

    state = {
      data: null,
      optInStatus: null,
    };

    componentDidMount = () => {
      if (!this.props.isMCC) {
        this.reload();
      }
    };

    componentWillUnmount = () => {
      this.cancel();
    };

    reload = () => {
      this.cancel();
      this.loadToken = createAsyncToken(this.props.dataService
        .getAutoApplyOptInStatus().finally(withUiBlock($('.recommendations-page'))))
        .on({
          onSuccess: ({
            data,
          }) => {
            const parsedData = this.parse(data.value);
            this.setState({
              data: parsedData.parsedData,
              optInStatus: parsedData.optInStatus,
            });
          },
        });
    };

    cancel = () => {
      if (this.loadToken) {
        this.loadToken.cancel();
      }
    };

    parse = (rawData) => {
      const parsedData = {};
      const optInStatus = {};
      _.each(rawData, (data) => {
        if (_.contains(SUPPORT_ADINSIGHT_AUTO_APPLY_TYPES, data.RecommendationType)) {
          parsedData[data.RecommendationType] = { ...data };
          optInStatus[data.RecommendationType] = data.IsOptIn;
        }
      });

      return { optInStatus, parsedData };
    };

    render = () => {
      if (this.state.data === null) return null;

      return (<WrappedComponent
        data={this.state.data}
        optInStatus={this.state.optInStatus}
        propsId={generateGuid()}
        reload={this.reload}
        {...this.props}
      />);
    };
  }

  return hoistNonReactStatics(HoC, WrappedComponent);
};
